import { createContext, useContext } from 'react';
import { type OrgSummary } from '../api/client';

export type OrgStatus = 'idle' | 'loading' | 'ready' | 'error';

export interface OrgContextValue {
  status: OrgStatus;
  orgs: OrgSummary[];
  /** The active org — the first membership, or null when there are none. */
  currentOrg: OrgSummary | null;
  /** The error from the last failed load (only meaningful when status==='error'). */
  error: unknown;
  /** Re-fetches memberships; resolves with the fetched list, rejects on failure. */
  refresh: () => Promise<OrgSummary[]>;
  /** Seeds a just-created org into state without a round-trip. */
  addOrg: (created: OrgSummary) => void;
}

export const OrgContext = createContext<OrgContextValue | null>(null);

export function useOrg(): OrgContextValue {
  const ctx = useContext(OrgContext);
  if (!ctx) {
    throw new Error('useOrg must be used within an OrgProvider');
  }
  return ctx;
}
